import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProductInfo from "./productInfo";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const ProductImage = () => {
  const { id } = useParams(); // Assuming you're using react-router for routing and getting the product id from URL parameters
  const [product, setProduct] = useState({});
  const [selectedImage, setSelectedImage] = useState("");
  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true); // Set loading state to true
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/product/${id}`); // Adjust the API endpoint as needed
        setProduct(response.data);
        if (response.data.images && response.data.images.length > 0) {
          setSelectedImage(response.data.images[0]);
        }
      } catch (error) {
        console.error("Error fetching the product:", error);
      } finally {
        setLoading(false); // Set loading state to false after fetching
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return (
      <div className="p-4 rounded-lg transition duration-300 flex flex-col lg:flex-row mb-20">
        <div className="hidden lg:flex flex-row w-full lg:w-1/2 mt-20">
          <div className="flex flex-col space-y-2 items-center">
            {Array(4).fill().map((_, index) => (
              <Skeleton key={index} width={112} height={112} className="rounded-lg" />
            ))}
          </div>
          <div className="pl-6 w-10/12">
            <Skeleton width="100%" height="100%" />
          </div>
        </div>

        <div className="lg:hidden mt-16">
          <Skeleton width="100%" height={300} />
          <div className="flex justify-center mt-2">
            {Array(4).fill().map((_, index) => (
              <Skeleton key={index} width={64} height={64} className="rounded-lg mx-1" />
            ))}
          </div>
        </div>

        <div className="w-full lg:w-1/2 mt-4 lg:mt-20">
          <Skeleton count={5} />
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 rounded-lg transition duration-300 flex flex-col lg:flex-row mb-20">
      <div className="hidden lg:flex flex-row w-full lg:w-1/2 mt-20">
        <div className="flex flex-col space-y-2 items-center">
          {product.images && product.images.map((image, index) => (
            <img
              key={index}
              src={`${process.env.REACT_APP_URL}/${image}`}
              alt={product.name}
              className={`w-28 h-28 object-cover cursor-pointer rounded-lg shadow-md ${selectedImage === image ? "border-2 border-gray-800" : ""}`}
              onClick={() => setSelectedImage(image)}
            />
          ))}
        </div>
        <div className="pl-6 w-10/12">
          <img
            src={`${process.env.REACT_APP_URL}/${selectedImage}`}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Mobile view: show single image with slider functionality */}
      <div className="lg:hidden mt-16">
        <img
          src={`${process.env.REACT_APP_URL}/${selectedImage}`}
          alt={product.name}
          className="w-full h-full object-cover"
        />
        <div className="flex justify-center mt-2">
          {product.images && product.images.map((image, index) => (
            <div key={index} className="mx-1">
              <img
                src={`${process.env.REACT_APP_URL}/${image}`}
                alt={product.name}
                className={`w-16 h-16 object-cover cursor-pointer rounded-lg shadow-md ${selectedImage === image ? "border-2 border-gray-800" : ""}`}
                onClick={() => setSelectedImage(image)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Right section for product info */}
      <ProductInfo product={product} />
    </div>
  );
};

export default ProductImage;
